export default "__VITE_ASSET__CdDFvjlv__"